// extracted by mini-css-extract-plugin
export var blockedMessage = "_5o-3";
export var blockedOverlay = "_5o-1";
export var fadeIn = "_5o-2";
export var hereLink = "_5o-0";
export var slideUp = "_5o-4";